import "../../style/LifeCounter.css"

const LifeCounter = ({heartMax, heart}) => {

  const heartsArray = Array.from({ length: heartMax }, (_, index) => index < heart);

  return (
    <div>
        <p className="lifeCounter_text sr_only">{`Sur vos ${heartMax} coeurs, il vous en reste ${heart}`}</p>
        <ul className="lifeCounter_heartList">
            {
                heartsArray.map((heart, index)=>
                    <li key={index} className={`lifeCounter_heart ${heart?'filled':'empty'}`}>♥</li>
                )
            }
        </ul>
    </div>
  );
};

export default LifeCounter;
